<template>
  <div class="case-schedule-item">
    <div class="f-between w-100b">
      <div class="axis f-column f-y-center m-r-25">
        <div class="dian" :class="`state-${state}`"></div>
        <div v-if="!hideBorder" class="xian f-1"></div>
      </div>
      <div class="f-between f-1">
        <div class="f-column">
          <div class="font m-b-10">{{title}}</div>
          <div class="gray-font">{{time}}</div>
        </div>
        <div class="state-btn font white-font" :class="`state-${state}`">{{stateBtnMap[state]}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'
// /news/details/:id
export default {
  props: {
    state: Number,
    title: String,
    time: String,
    hideBorder: Boolean,
  },
  setup(props, { emit }) {
    const toDetails = () => {
      router.push('/case/details/2')
    }
    const stateBtnMap = {
      1: '未开始',
      2: '进行中',
      3: '已完成',
    }
    return { toDetails, stateBtnMap }
  },
}
</script>

<style lang="scss">
.case-schedule-item {
  display: flex;
  height: 110px;
  padding-left: 30px;
  padding-right: 30px;
  .axis {
    transform: translateY(8px);
  }
  .dian {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .xian {
    width: 1px;
    background-color: #dddde5;
  }
  .state-1 {
    background-color: #d8d8d8;
  }
  .state-2 {
    background-color: #fe9400;
  }
  .state-3 {
    background-color: #2ecb8a;
  }
  .gray-font {
    color: #a2a2a2 !important;
  }
  .state-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 58px;
    border-radius: 8px;
  }
}
</style>